import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = { class: "note-page-container" };
var _hoisted_2 = {
    class: "note-view-container",
    id: "macy-note-container"
};
var _hoisted_3 = { class: "note-load-more" };
var _hoisted_4 = {
    class: "note-load-more-content",
    id: "note-load-more-content"
};
import Macy from "macy";
import { ref, onMounted, watch, nextTick, onBeforeUnmount, } from "vue";
import SingleNote from "@/components/BlogComponents/SingleNote.vue";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotePage',
    setup: function (__props) {
        var _this = this;
        // @ts-ignore
        var loadContentElement = null;
        var noteContentContainer = null;
        var currentOffset = 1;
        var isLoading = false;
        var loadMoreContent = ref("滑 动 加 载 更 多");
        window.resourceBaseUrl = "https://".concat(window.location.host, "/note");
        // 在使用 ref 时，使用notes.value.push()的话，不会触发 watch
        var notes = ref([]);
        var macy;
        function addNote(isWithMask) {
            if (isWithMask === void 0) { isWithMask = false; }
            isLoading = true;
            loadMoreContent.value = "正 在 加 载...";
            var requestFunc = isWithMask ? api.request : api.requestWithoutMask;
            requestFunc.get("/notelist?offset=".concat(currentOffset)).then(function (resp) {
                var _a, _b;
                if (resp.data === null || resp.data.length < 15) {
                    if (!noteContentContainer)
                        throw new Error("noteContentContainer is null");
                    noteContentContainer.removeEventListener("scroll", loadMoreNote);
                    loadMoreContent.value = "没 有 更 多 了";
                    if (resp.data === null)
                        return;
                    else
                        (_a = notes.value).push.apply(_a, resp.data);
                    isLoading = false;
                    return;
                }
                (_b = notes.value).push.apply(_b, resp.data);
                currentOffset++;
                loadMoreContent.value = "滑 动 加 载 更 多";
                isLoading = false;
            });
        }
        // 懒加载
        function loadMoreNote() {
            // 此处与博客网站的滚动判断逻辑不同，原先的博客网站的滚动为 window 整个视口滚动，而这个仅仅是 noteContentContainer 的滚动
            // 因此，对 noteContentContainer 进行滚动监听，同时由于加载更多这个元素是放在 noteContentContainer 的下三层的子元素下的，所以判断是否出现在视口的逻辑也有所不同
            console.log("scroll event triggered");
            if (isLoading)
                return;
            if (!loadContentElement)
                throw new Error("loadContentElement is null");
            if (!noteContentContainer)
                throw new Error("noteContentContainer is null");
            var rect = loadContentElement.getBoundingClientRect();
            var containerRect = noteContentContainer.getBoundingClientRect();
            if (rect.top >= containerRect.top && rect.bottom <= containerRect.bottom) {
                console.log("add note");
                addNote();
            }
        }
        addNote(true);
        function onDeleteNote(noteID) {
            var index = notes.value.findIndex(function (note) { return note.id === noteID; });
            if (index !== -1) {
                notes.value.splice(index, 1);
            }
            else {
                window.$notifyError("删除失败", "随记不存在");
            }
        }
        onMounted(function () {
            // if (window.setLive2DTalkContent) {
            //   window.setLive2DTalkContent("随记");
            // }
            macy = Macy({
                container: "#macy-note-container",
                trueOrder: false,
                waitForImages: false,
                margin: 12,
                columns: 3,
                breakAt: {
                    520: 2,
                    400: 1,
                },
            });
            watch(notes.value, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, nextTick()];
                        case 1:
                            _a.sent(); // 等待 notes 挂载渲染完成
                            macy.recalculate(true);
                            return [2 /*return*/];
                    }
                });
            }); });
            loadContentElement = document.getElementById("note-load-more-content");
            noteContentContainer = window.menuContentContainerRef.value;
            console.log("noteContentContainer", noteContentContainer);
            if (!noteContentContainer)
                throw new Error("noteContentContainer is null");
            noteContentContainer.addEventListener("scroll", loadMoreNote);
        });
        onBeforeUnmount(function () {
            if (noteContentContainer) {
                noteContentContainer.removeEventListener("scroll", loadMoreNote);
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, function (noteItem, noteIndex) {
                        return (_openBlock(), _createBlock(SingleNote, {
                            propNote: noteItem,
                            propIndex: noteIndex,
                            macy: _unref(macy),
                            key: noteItem.id,
                            comment: "加唯一key防止其遍历 notes 时渲染错误（仅删除最后一个元素而非删除当前元素）",
                            onDelete: onDeleteNote
                        }, null, 8, ["propNote", "propIndex", "macy"]));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(loadMoreContent)), 1)
                ])
            ]));
        };
    }
});
